import { useEffect, useState } from "react";
import { ReportConfigV2, ReportExtras } from "@/common/report-configuration";
import { getReportDataV2 } from "@/lib/serverComm";

export const useReportDataV2 = (config: ReportConfigV2) => {
  const [data, setData] = useState<any[]>([]); // eslint-disable-line @typescript-eslint/no-explicit-any
  const [extras, setExtras] = useState<ReportExtras>({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [prevConfig, setPrevConfig] = useState<ReportConfigV2>();

  useEffect(() => {
    console.log("Report config changed:", config);
    // If config hasn't changed, skip fetching data
    if (prevConfig && JSON.stringify(prevConfig) === JSON.stringify(config)) {
      return;
    }

    // Now, only some properties of the config are relevant for fetching data
    // So we can skip fetching if those have not changed.
    const isFunnelChart = config.chart.chartType === "Funnel";
    if (
      prevConfig &&
      JSON.stringify(prevConfig.data) === JSON.stringify(config?.data) &&
      !isFunnelChart &&
      (prevConfig.chart.limit === config.chart.limit ||
        !config.data.includeProjections)
    ) {
      return;
    }

    setPrevConfig(config);

    // Reset state when config is null or invalid
    if (!config || !config.data.datasetName) {
      setData([]);
      setLoading(false);
      setError(null);
      setExtras({});
      return;
    }

    const fetchData = async () => {
      try {
        if (config.data.measures.length === 0) {
          setData([]);
          setExtras({});
          return;
        }
        setLoading(true);
        setError(null);
        const { reportData, extras } = await getReportDataV2(config);
        console.log("Fetched report data:", reportData);
        console.log("Fetched report extras:", extras);
        setData(reportData);
        setExtras(extras);
        // Return chart settings for external use
      } catch (error) {
        const message =
          error instanceof Error ? error.message : "An unknown error occurred";
        setError(`Failed to fetch report data: ${message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [config, prevConfig]);

  return { data, extras, loading, error };
};
